import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

import faqFactory, { PublicVarsInterface as FaqSetupInterface } from '../../../../libs/faq/faq-service';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesEscrowAgreementFaqTopHeaderCls: string;
			investorsResourcesEscrowAgreementFaqTopTextInfoCls: string;
			investorsResourcesEscrowAgreementFaqDisplayAllBtnCls: string;
			investorsResourcesEscrowAgreementFaqItemCls: string;
			investorsResourcesEscrowAgreementFaqBottomSubheaderCls: string;
			investorsResourcesEscrowAgreementFaqBottomTextInfoCls: string;
			investorsResourcesEscrowAgreementFaqWrapperCls: string;
		}
	},

	faqSetup?: FaqSetupInterface

	slug: string
}

class Faq extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Escrow Agreement Faq Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.faqSetup) {
			this.errorMsg('faqSetup is not defined');
		} else {
			const faq = faqFactory.create();
			faq.init(this.publicVars.faqSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqTopHeaderCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__flipInX', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqTopTextInfoCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__flipInX', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqDisplayAllBtnCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqWrapperCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn', once: true});

		//BTODO gsap memoizes position so when faq item is opened it changes vertical size causing errors - improper position trigerring gsap scroll effects
		//after changing layout all setup that is below should be invalidated and recalculated
		/*
		document.querySelector("#invalidate").addEventListener("click", function() {
		  t.invalidate();
		  t.restart();
		});
		 */

		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '1', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '2', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '3', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '4', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '5', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '6', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '7', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '8', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqItemCls + '9', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqBottomSubheaderCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesEscrowAgreementFaqBottomTextInfoCls || '', 'investors_resources_escrow_agreeement_faq', { animCls: 'animate__fadeIn'});



	}

	bind() {
		this.msg('bind');
	}
}

export default Faq;